export default "__VITE_ASSET__ClverRKW__"